// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.minmax-label{font:10px Helvetica,sans;text-shadow:none}`, "",{"version":3,"sources":["webpack://./src/library/minmax.css"],"names":[],"mappings":"AAAA,cACC,wBAA4B,CAC5B,gBACD","sourcesContent":[".minmax-label {\n\tfont: 10px \"Helvetica\", sans;\n\ttext-shadow: initial;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
